module.exports = __webpack_public_path__ + "1.5.0-unryo/img/mysql.185aa95c.svg";